/* eslint-disable no-underscore-dangle */
export const FETCH_START         = 'FETCH_START';
export const FETCH_FINISH        = 'FETCH_FINISH';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';

export const CREATE_ORDER       = 'CREATE_ORDER';
export const ORDER_COMPLETED    = 'ORDER_COMPLETED';
export const _3DS_ORDER         = '_3DS_ORDER';
export const _3DSV2_ORDER       = '_3DSV2_ORDER';
export const _3DSV2_ORDER_CLEAR = '_3DSV2_ORDER_CLEAR';

export const PAYER_INFO_CHANGED = 'PAYER_INFO_CHANGED';
export const CARD_INFO_CHANGED  = 'CARD_INFO_CHANGED';

export const SELECT_PAYMENT_METHOD          = 'SELECT_PAYMENT_METHOD';
export const UPDATE_PAYMENT_FORM_VALIDATION = 'UPDATE_PAYMENT_FORM_VALIDATION';

export const OPEN_POPUP                 = 'OPEN_POPUP';
export const CLOSE_POPUP                = 'CLOSE_POPUP';
export const OPEN_REDEMPTION_SMS_POPUP  = 'OPEN_REDEMPTION_SMS_POPUP';
